import React, { useState, useEffect } from "react";
import { GetParcelsInPark, Getallparcels } from "../../CommonData/CommonData";
import { ParkList } from "../../PreRenderedComponents";
import { IPDCReportTemplate } from "../../../../../components";
import { Grid, CircularProgress, Button } from "@mui/material";
import { Search } from "@mui/icons-material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

export default function ParcelList() {
  const [data, setData] = useState([]);
  const [selectedPark, setSelectedPark] = useState(null);
  const [loading, setLoading] = useState(false);
  const decodedUser = useDecodedUser();

  // Function to fetch all investors
  const fetchAllInvestors = async () => {
    try {
      setLoading(true);
      let allInvestors = await Getallparcels(); // Assuming you have this API function
      // Remove geometry if exists
      const filteredInvestors = allInvestors?.map(({ geometry, ...rest }) => rest);
      filteredInvestors && filteredInvestors?.length > 0
        ? setData(filteredInvestors)
        : setData([]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Function to search parcels in selected park
  const fetchParcelsInPark = async () => {
    try {
      setLoading(true);
      if (selectedPark) {
        let tempParcel = await GetParcelsInPark(selectedPark?.id, false);
        //remove geometry from parcel
        const filteredParcel = tempParcel?.map(({ geometry, ...rest }) => rest);
        filteredParcel && filteredParcel?.length > 0
          ? setData(filteredParcel)
          : setData([]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Fetch all investors when component mounts
  useEffect(() => {
    fetchAllInvestors();
  }, []); // Empty dependency array = runs once on mount

  if (loading) return <CircularProgress />;
  
  return (
    <>
      <Grid container className="no-print" spacing={2} ml={1} mb={2}>
        <Grid item xs={12} md={6}>
          <ParkList
            selectedPark={selectedPark}
            setSelectedPark={setSelectedPark}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Button
            startIcon={<Search />}
            onClick={fetchParcelsInPark}
            variant="contained"
            color="primary"
            fullWidth={true}
          >
            Search
          </Button>
        </Grid>
      </Grid>
      <>
        {data && data?.length > 0 ? (
          <IPDCReportTemplate
            data={data}
            setData={setData}
            defaultTitle="Investors List"
            isEditable={false}
            isPrintable={false}
            showWhatToDisplay={true}
          />
        ) : (
          <div>No Investors Found</div>
        )}
      </>
    </>
  );
}